module.exports = __webpack_public_path__ + "organigramme/img/mascotte_smile-s.af205b58.svg";